import { render, staticRenderFns } from "./CouponRule.vue?vue&type=template&id=17cea944&"
import script from "./CouponRule.vue?vue&type=script&lang=js&"
export * from "./CouponRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports